<!-- Modal chips -->
<ng-template #modalChipsEl let-modal>
    <div class="modal-header">
        <h2 class="modal-title" id="myModalLabel1">Chips cobrados</h2>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0" ngbAutofocus>

        <div class="card">

            <!-- <h2 style="padding: 1%; font-weight: 500;">Detalhamento de ICCIDS</h2>
            <hr style=""> -->
            <!-- DATATABLE -->
            <ngx-datatable class="material core-bootstrap" [rowHeight]="58" [limit]="10" columnMode="force"
                [reorderable]="false" [swapColumns]="false" [footerHeight]="50" [headerHeight]="120"
                style="box-shadow: none" [rows]="rows_iccid" [scrollbarH]="true">

                <!-- COLUNA -->
                <ngx-datatable-column [sortable]="false">
                    <ng-template let-column="column" ngx-datatable-header-template>
                        <h4>OPERADORA</h4>
                        <input type="search" placeholder="OPERADORA" class="ml-25 form-control"
                            (keyup)="textFilterChips($event, 'operadora')" />
                    </ng-template>
                    <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
                        <div class="datatable-row">
                            <span class="font-weight-bold">{{row.operadora }}</span>
                        </div>
                    </ng-template>
                </ngx-datatable-column>

                <!-- COLUNA -->
                <ngx-datatable-column [sortable]="false">
                    <ng-template let-column="column" ngx-datatable-header-template>
                        <h4>SERIAL</h4>
                        <input type="search" placeholder="SERIAL" class="ml-25 form-control"
                            (keyup)="textFilterChips($event, 'serial')" />
                    </ng-template>
                    <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
                        <div class="datatable-row">
                            <span class="font-weight-bold">{{row.serial }}</span>
                        </div>
                    </ng-template>
                </ngx-datatable-column>

                <!-- COLUNA -->
                <ngx-datatable-column [sortable]="false">
                    <ng-template let-column="column" ngx-datatable-header-template>
                        <h4>NUMERO</h4>
                        <input type="search" placeholder="NUMERO" class="ml-25 form-control"
                            (keyup)="textFilterChips($event, 'numero')" />
                    </ng-template>
                    <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
                        <div class="datatable-row">
                            <span class="font-weight-bold">{{row.numero }}</span>
                        </div>
                    </ng-template>
                </ngx-datatable-column>

            </ngx-datatable>
        </div>

    </div>
</ng-template>
<!-- / Modal importacao-->

<ng-template #modalFaleflexAdd let-modal>
    <div class="modal-header">
        <h2 class="modal-title" id="modalFaleflexTitle">{{ isEditingFaleflex ? 'Editar item Faleflex' : 'Adicionar item Faleflex' }}</h2>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        <div class="form-group">
            <label>Serviço</label>
            <select class="form-control" [(ngModel)]="novoFaleflex.id_servico">
                <option *ngFor="let s of availableServicosFaleflex" [ngValue]="s.id_servico">{{ s.nome }}</option>
            </select>
            <small *ngIf="availableServicosFaleflex.length === 0" class="text-muted">Todos os serviços já incluídos.</small>
        </div>
        <div class="form-group">
            <label>Quantidade</label>
            <input type="number" min="1" class="form-control" [(ngModel)]="novoFaleflex.quantidade" (ngModelChange)="onChangeFaleflex()">
        </div>
        <div class="form-group">
            <label>Valor venda</label>
            <input type="number" step="0.01" class="form-control" [(ngModel)]="novoFaleflex.tarifa_venda" (ngModelChange)="onChangeFaleflex()">
        </div>
        <div class="form-group">
            <label>Valor Total</label>
            <input type="number" step="0.01" class="form-control" [ngModel]="novoFaleflex.preco_total" readonly>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss('cancel')">Cancelar</button>
        <button type="button" class="btn btn-primary" [disabled]="(!isEditingFaleflex && availableServicosFaleflex.length === 0) || !novoFaleflex.id_servico || !novoFaleflex.quantidade || !novoFaleflex.tarifa_venda" (click)="addFaleflexItem()">{{ isEditingFaleflex ? 'Salvar' : 'Adicionar' }}</button>
    </div>
</ng-template>

<div class="content-wrapper">
    <div class="content-wrapper">
        <div class="content-body">

            <app-content-header [contentHeader]="contentHeader"></app-content-header>

            <div class="row invoice-add">
                <div class="col-xl-12 col-md-8 col-12">

                    <div class="card">
                        <div class="card-body">
                        <!-- {{Cliente | json}} -->
                            <h5 class="card-title" style="margin-bottom: 0%;">{{Cliente.razao_social}} - {{Cliente.cpf_cnpj_cliente}}</h5>  
                            <h6 class="card-subtitle">{{Cliente.nome_fantasia }}</h6>
                            <!-- <h6>{{rows_veiculos[0].id_status }}</h6> -->
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xl-9 col-md-8 col-12">
                            <div class="card">

                                <h2 style="padding: 1%; font-weight: 500;">Detalhamento de Veículos</h2>
                                <hr style="">
                                <!-- DATATABLE -->
                                <ngx-datatable class="material core-bootstrap" [rowHeight]="58" [limit]="10"
                                    columnMode="force" [reorderable]="false" [swapColumns]="false" [footerHeight]="50"
                                    [headerHeight]="120" style="box-shadow: none" [rows]="rows_veiculos"
                                    [scrollbarH]="true">

                                    <!-- COLUNA -->
                                    <ngx-datatable-column [sortable]="false">
                                        <ng-template let-column="column" ngx-datatable-header-template>
                                            <h4>Total de Veículos</h4>
                                            <input type="search" placeholder="Total de Veículos"
                                                class="ml-25 form-control"
                                                (keyup)="textFilterVeiculo($event, 'total_veiculo')" />
                                        </ng-template>
                                        <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex"
                                            let-value="value" let-row="row">
                                            <div class="datatable-row">
                                                <span class="font-weight-bold"
                                                    [ngStyle]="{'text-decoration': !flgVeiculos ? 'line-through' : 'none'}">{{row.total_veiculo
                                                    }}</span>
                                            </div>
                                        </ng-template>
                                    </ngx-datatable-column>

                                    <!-- COLUNA -->
                                    <ngx-datatable-column [sortable]="false">
                                        <ng-template let-column="column" ngx-datatable-header-template>
                                            <h4>Valor/Veículo</h4>
                                            <input type="search" placeholder="Valor/Veículo" class="ml-25 form-control"
                                                (keyup)="textFilterVeiculo($event, 'valor_cobrado')" />
                                        </ng-template>
                                        <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex"
                                            let-value="value" let-row="row">
                                            <div class="datatable-row">
                                                <span class="font-weight-bold"
                                                    [ngStyle]="{'text-decoration': !flgVeiculos ? 'line-through' : 'none'}">R$
                                                    {{row.valor_cobrado }}</span>
                                            </div>
                                        </ng-template>
                                    </ngx-datatable-column>

                                    <!-- COLUNA -->
                                    <ngx-datatable-column [sortable]="false">
                                        <ng-template let-column="column" ngx-datatable-header-template>
                                            <h4>Valor Total</h4>
                                            <input type="search" placeholder="Valor Total" class="ml-25 form-control"
                                                (keyup)="textFilterVeiculo($event, 'valor_cobrado_total')" />
                                        </ng-template>
                                        <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex"
                                            let-value="value" let-row="row">
                                            <div class="datatable-row">
                                                <span class="font-weight-bold"
                                                    [ngStyle]="{'text-decoration': !flgVeiculos ? 'line-through' : 'none'}">R$
                                                    {{row.valor_cobrado_total || currencyMask }}</span>
                                            </div>
                                        </ng-template>
                                    </ngx-datatable-column>

                                </ngx-datatable>
                            </div>

                            <div class="card" [hidden]="flgChip === 0 || flgTeste === 1">

                                <h2 style="padding: 1%; font-weight: 500;">Detalhamento de Chips</h2>
                                <hr>
                                <!-- DATATABLE -->
                                <ngx-datatable class="material core-bootstrap" [rowHeight]="58" [limit]="10"
                                    columnMode="force" [reorderable]="false" [swapColumns]="false" [footerHeight]="50"
                                    [headerHeight]="120" style="box-shadow: none" [rows]="rows_chips"
                                    [scrollbarH]="true">

                                    <!-- COLUNA -->
                                    <ngx-datatable-column [sortable]="false">
                                        <ng-template let-column="column" ngx-datatable-header-template>
                                            <h4>Operadora</h4>
                                            <input type="search" placeholder="Operadora" class="ml-25 form-control"
                                                (keyup)="textFilterCliente($event, 'operadora')" />
                                        </ng-template>
                                        <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex"
                                            let-value="value" let-row="row">
                                            <div class="datatable-row">
                                                <span class="font-weight-bold">{{row.operadora }}</span>
                                            </div>
                                        </ng-template>
                                    </ngx-datatable-column>

                                    <!-- COLUNA -->
                                    <ngx-datatable-column [sortable]="false">
                                        <ng-template let-column="column" ngx-datatable-header-template>
                                            <h4>Quantidade</h4>
                                            <input type="search" placeholder="Quantidade" class="ml-25 form-control"
                                                (keyup)="textFilterCliente($event, 'quantidade')" />
                                        </ng-template>
                                        <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex"
                                            let-value="value" let-row="row">
                                            <div class="datatable-row">
                                                <span class="font-weight-bold">{{row.quantidade }}</span>
                                            </div>
                                        </ng-template>
                                    </ngx-datatable-column>

                                    <!-- COLUNA -->
                                    <ngx-datatable-column [sortable]="false">
                                        <ng-template let-column="column" ngx-datatable-header-template>
                                            <h4>Valor unidade</h4>
                                            <input type="search" placeholder="Valor Unidade" class="ml-25 form-control"
                                                (keyup)="textFilterCliente($event, 'valor_unidade')" />
                                        </ng-template>
                                        <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex"
                                            let-value="value" let-row="row">
                                            <div class="datatable-row">
                                                <span class="font-weight-bold">{{row.valor_unidade }}</span>
                                            </div>
                                        </ng-template>
                                    </ngx-datatable-column>

                                    <!-- COLUNA -->
                                    <ngx-datatable-column [sortable]="false">
                                        <ng-template let-column="column" ngx-datatable-header-template>
                                            <h4>Valor Total</h4>
                                            <input type="search" placeholder="Valor Total" class="ml-25 form-control"
                                                (keyup)="textFilterCliente($event, 'valor_total')" />
                                        </ng-template>
                                        <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex"
                                            let-value="value" let-row="row">
                                            <div class="datatable-row">
                                                <span class="font-weight-bold">{{row.valor_total }}</span>
                                            </div>
                                        </ng-template>
                                    </ngx-datatable-column>

                                    <!-- COLUNA -->
                                    <ngx-datatable-column [sortable]="false">
                                        <ng-template let-column="column" ngx-datatable-header-template>
                                            <h4>Ações</h4>
                                        </ng-template>
                                        <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex"
                                            let-value="value" let-row="row">
                                            <div class="datatable-row">
                                                <button class="btn btn-secondary"
                                                    (click)="modalChips(modalChipsEl, row.operadora)">
                                                    <span>Chips</span>
                                                </button>
                                            </div>
                                        </ng-template>
                                    </ngx-datatable-column>



                                </ngx-datatable>
                            </div>
                        </div>
                        <!-- Coluna lateral: Rastreei -->
                        <div class="col-md-3 col-12 mt-md-0 mt-2">
                            <div class="card">
                                <div class="card-body">
                                    <h5 class="card-title" style="margin-bottom: 0%;">Rastreei</h5>
                                    <h6 class="card-subtitle">Detalhamento de envio</h6>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-body">
                                    <div class="form-group mb-2">
                                        <label for="basicSelect">Cobrar Veiculos?:</label>
                                        <div><span>{{labelCobranca(flgVeiculos)}}</span></div>
                                    </div>
                                    <div class="form-group mb-2">
                                        <label for="basicSelect">Cobrar Chips?:</label>
                                        <div><span>{{labelCobranca(flgChip)}}</span></div>
                                    </div>

                                    <button routerLink="/fechamento/{{idFechamento}}/clientes/"
                                        class="btn btn-outline-primary btn-block mb-75 imprimir" rippleEffect>
                                        Voltar
                                    </button>

                                    <button class="btn btn-primary btn-block mb-75" rippleEffect
                                        (click)="sendBoleto(idCliente, idFechamento)" [disabled]="isvendaDisabled()">
                                        <span *ngIf="spinnerImportar"
                                            class="spinner-border spinner-border-sm mr-1"></span>
                                        <span>Gerar Venda</span>
                                    </button>

                                    <div class="btn-group btn-block mb-75" ngbDropdown>
                                        <button id="dropdown-basic" class="btn btn-primary dropdown-toggle" ngbDropdownToggle
                                            aria-haspopup="true" aria-expanded="false">
                                            Compartilhar
                                        </button>
                                        <div ngbDropdownMenu aria-labelledby="dropdown-basic">
                                            <button class="dropdown-item" [disabled]="isCompartilharDisabled()"
                                                (click)="sendBoletoOne(idCliente, idFechamento)">
                                                <span *ngIf="spinnerImportarBoleto"
                                                    class="spinner-border spinner-border-sm mr-1"></span>
                                                Compartilhar boleto por Email
                                            </button>
                                            <button class="dropdown-item" [disabled]="isCompartilharDisabled()"
                                                (click)="shareByWhatsApp(idCliente, idFechamento)">
                                                Compartilhar boleto por WhatsApp
                                            </button>
        
                                            <button class="dropdown-item" [disabled]="isCompartilharDisabled()"
                                                (click)="shareByVeiculo(idCliente, idFechamento)">
                                                Dados de Veículos
                                            </button>
                                            <button class="dropdown-item" [disabled]="isCompartilharDisabled()"
                                                (click)="shareBychip(idCliente, idFechamento)">
                                                Dados de Chips
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Detalhamento da Faleflex -->
                    <!-- ROW PRINCIPAL -->
                    <div class="row">
                        <!-- COLUNA: DATATABLE -->
                        <div class="col-xl-9 col-md-8 col-12" [hidden]="flgTeste === 1">
                            <div class="card">
                                <h2 style="padding: 1%; font-weight: 500;">Detalhamento de Faleflex</h2>
                                <hr>
                                <div class="px-2 pb-1">
                                    <button class="btn btn-outline-primary" [disabled]="isvendaDisabledFaleFlex()" (click)="openModalFaleflex(modalFaleflexAdd)">Adicionar item</button>
                                </div>

                                <!-- DATATABLE -->
                                <ngx-datatable class="material core-bootstrap" [rowHeight]="58" [limit]="10"
                                    columnMode="force" [reorderable]="false" [swapColumns]="false" [footerHeight]="50"
                                    [headerHeight]="120" style="box-shadow: none" [rows]="rows_faleflex"
                                    [scrollbarH]="true">

                                    <!-- COLUNA: Nome -->
                                    <ngx-datatable-column [sortable]="false">
                                        <ng-template let-column="column" ngx-datatable-header-template>
                                            <h4>Nome</h4>
                                            <input type="search" placeholder="Nome" class="ml-25 form-control"
                                                (keyup)="textFilterCliente($event, 'nome')" />
                                        </ng-template>
                                        <ng-template ngx-datatable-cell-template let-row="row">
                                            <div class="datatable-row">
                                                <span class="font-weight-bold">{{ row.nome }}</span>
                                            </div>
                                        </ng-template>
                                    </ngx-datatable-column>

                                    <!-- COLUNA: Quantidade -->
                                    <ngx-datatable-column [sortable]="false">
                                        <ng-template let-column="column" ngx-datatable-header-template>
                                            <h4>Quantidade</h4>
                                            <input type="search" placeholder="Quantidade" class="ml-25 form-control"
                                                (keyup)="textFilterCliente($event, 'quantidade')" />
                                        </ng-template>
                                        <ng-template ngx-datatable-cell-template let-row="row">
                                            <div class="datatable-row">
                                                <span class="font-weight-bold">{{ row.quantidade }}</span>
                                            </div>
                                        </ng-template>
                                    </ngx-datatable-column>

                                    <!-- COLUNA: Valor venda -->
                                    <ngx-datatable-column [sortable]="false">
                                        <ng-template let-column="column" ngx-datatable-header-template>
                                            <h4>Valor venda</h4>
                                            <input type="search" placeholder="Valor venda" class="ml-25 form-control"
                                                (keyup)="textFilterCliente($event, 'tarifa_venda')" />
                                        </ng-template>
                                        <ng-template ngx-datatable-cell-template let-row="row">
                                            <div class="datatable-row">
                                                <span class="font-weight-bold">{{ row.tarifa_venda }}</span>
                                            </div>
                                        </ng-template>
                                    </ngx-datatable-column>

                                    <!-- COLUNA: Valor total -->
                                    <ngx-datatable-column [sortable]="false">
                                        <ng-template let-column="column" ngx-datatable-header-template>
                                            <h4>Valor Total</h4>
                                            <input type="search" placeholder="Valor total" class="ml-25 form-control"
                                                (keyup)="textFilterCliente($event, 'preco_total')" />
                                        </ng-template>
                                        <ng-template ngx-datatable-cell-template let-row="row">
                                            <div class="datatable-row">
                                                <span class="font-weight-bold">{{ row.preco_total }}</span>
                                            </div>
                                        </ng-template>
                                    </ngx-datatable-column>

                                    <!-- COLUNA: Ações -->
                                    <ngx-datatable-column [sortable]="false">
                                        <ng-template let-column="column" ngx-datatable-header-template>
                                            <h4>Ações</h4>
                                        </ng-template>
                                        <ng-template ngx-datatable-cell-template let-row="row">
                                            <div class="datatable-row">
                                                <button class="btn btn-sm btn-outline-primary mr-50" [disabled]="isvendaDisabledFaleFlex()" (click)="editFaleflex(row, modalFaleflexAdd)">Editar</button>
                                                <button class="btn btn-sm btn-outline-danger" [disabled]="isvendaDisabledFaleFlex()" (click)="deleteFaleflex(row)">Excluir</button>
                                            </div>
                                        </ng-template>
                                    </ngx-datatable-column>

                                </ngx-datatable>
                            </div>
                        </div>

                        <!-- COLUNA: CARDS DE AÇÕES -->
                        <div class="col-xl-3 col-md-4 col-12 mt-md-0 mt-2">
                            <div class="card">
                                <div class="card-body">
                                    <h5 class="card-title" style="margin-bottom: 0%; color: #f15921;">Faleflex</h5>
                                    <h6 class="card-subtitle">Detalhamento de envio</h6>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-body">
                                    <!-- <div class="form-group mb-2">
                                        <label for="basicSelect">Cobrar Veículos?:</label>
                                        <div>
                                            <span>{{ flgVeiculos ? 'SIM' : 'NÃO' }}</span>
                                        </div>
                                    </div>
                                    <div class="form-group mb-2">
                                        <label for="basicSelect">Cobrar Chips?:</label>
                                        <div>
                                            <span>{{ flgChip ? 'SIM' : 'NÃO' }}</span>
                                        </div>
                                    </div> -->

                                    <button routerLink="/fechamento/{{idFechamento}}/clientes/"
                                        class="btn btn-outline-primary btn-block mb-75 imprimir" rippleEffect>
                                        Voltar
                                    </button>

                                    <button class="btn btn-primary btn-block mb-75" rippleEffect
                                        (click)="sendBoletoFaleflex(idCliente, idFechamento)" [disabled]="isvendaDisabledFaleFlex()">
                                        <span *ngIf="spinnerImportar"
                                            class="spinner-border spinner-border-sm mr-1"></span>
                                        <span>Gerar Venda</span>
                                    </button>

                                    <div class="btn-group btn-block mb-75" ngbDropdown>
                                        <button id="dropdown-basic" class="btn btn-primary dropdown-toggle"
                                            ngbDropdownToggle aria-haspopup="true" aria-expanded="false">
                                            Compartilhar
                                        </button>
                                        <div ngbDropdownMenu aria-labelledby="dropdown-basic">
                                            <button class="dropdown-item" [disabled]="isCompartilharDisabled()"
                                                (click)="sendBoletoOneFaleflex(idCliente, idFechamento)">
                                                <span *ngIf="spinnerImportarBoleto"
                                                    class="spinner-border spinner-border-sm mr-1"></span>
                                                Compartilhar boleto por Email
                                            </button>
                                            <button class="dropdown-item" [disabled]="isCompartilharDisabled()"
                                                (click)="shareByWhatsApp(idCliente, idFechamento)">
                                                Compartilhar boleto por WhatsApp
                                            </button>
                                            <!-- <button class="dropdown-item" [disabled]="isCompartilharDisabled()"
                                                (click)="shareByVeiculo(idCliente, idFechamento)">
                                                Dados de Veículos
                                            </button>
                                            <button class="dropdown-item" [disabled]="isCompartilharDisabled()"
                                                (click)="shareBychip(idCliente, idFechamento)">
                                                Dados de Chips
                                            </button> -->
                                        </div>
                                    </div>

                                    <button class="btn btn-success btn-block mb-75" rippleEffect
                                        (click)="gerarRelatorioCdrFaleflex()" [disabled]="spinnerRelatorioCdr"
                                        title="Excel com o detalhamento de CDR do mês vigente do fechamento">
                                        <span *ngIf="spinnerRelatorioCdr"
                                            class="spinner-border spinner-border-sm mr-1"></span>
                                        <span>Relatório Excel (CDR)</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>


                    <!-- Compartilhar Rastreei -->
                    <!-- <div class="col-xl-3 col-md-4 col-12 mt-md-0 mt-2">
                            <div class="card">
                                <div class="card-body">
                                    <h5 class="card-title" style="margin-bottom: 0%;">Rastreei</h5>
                                    <h6 class="card-subtitle">Detalhamento de envio</h6> -->
                    <!-- <h6>{{rows_veiculos[0].id_status }}</h6> -->
                    <!-- </div>
                            </div> -->

                    <!-- <div class="card">
                                <div class="card-body">
                                    <div class="form-group mb-2">
                                        <label for="basicSelect">Cobrar Veiculos?:</label>

                                        <div>
                                            <span>{{flgVeiculos ? 'SIM' : 'NÃO'}}</span>
                                        </div>
                                    </div>
                                    <div class="form-group mb-2">
                                        <label for="basicSelect">Cobrar Chips?:</label>

                                        <div>
                                            <span>{{flgChip ? 'SIM' : 'NÃO'}}</span>
                                        </div>
                                    </div>
                                    <button routerLink="/fechamento/{{idFechamento}}/clientes/"
                                        class="btn btn-outline-primary btn-block mb-75 imprimir" rippleEffect>
                                        Voltar
                                    </button>
                                    <button class="btn btn-primary btn-block mb-75" rippleEffect
                                        (click)="sendBoleto(idCliente, idFechamento)" [disabled]="isvendaDisabled()">
                                        <span *ngIf="spinnerImportar"
                                            class="spinner-border spinner-border-sm mr-1"></span>
                                        <span>Gerar Venda</span>
                                    </button>

                                    <div class="btn-group btn-block mb-75" ngbDropdown>
                                        <button id="dropdown-basic" class="btn btn-primary dropdown-toggle"
                                            ngbDropdownToggle aria-haspopup="true" aria-expanded="false">
                                            Compartilhar
                                        </button>
                                        <div ngbDropdownMenu aria-labelledby="dropdown-basic">
                                            <button class="dropdown-item" [disabled]="isCompartilharDisabled()"
                                                (click)="sendBoletoOne(idCliente, idFechamento)">
                                                <span *ngIf="spinnerImportarBoleto"
                                                    class="spinner-border spinner-border-sm mr-1"></span>
                                                Compartilhar boleto por Email
                                            </button>
                                            <button class="dropdown-item" [disabled]="isCompartilharDisabled()"
                                                (click)="shareByWhatsApp(idCliente, idFechamento)">
                                                Compartilhar boleto por WhatsApp
                                            </button>

                                            <button class="dropdown-item" [disabled]="isCompartilharDisabled()"
                                                (click)="shareByVeiculo(idCliente, idFechamento)">
                                                Dados de Veículos
                                            </button>
                                            <button class="dropdown-item" [disabled]="isCompartilharDisabled()"
                                                (click)="shareBychip(idCliente, idFechamento)">
                                                Dados de Chips
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                </div>
            </div>
        </div>
    </div>
